import { render, staticRenderFns } from "./EditComponent.vue?vue&type=template&id=820f33b8&"
import script from "./EditComponent.vue?vue&type=script&lang=ts&"
export * from "./EditComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports